import React, { useState } from 'react'
import './CommonDesignGallery.css';
import { Link } from 'react-router-dom';

import livingroomwithtvunit1 from '../../assets/designgallery/LivingRoom/livingroom_with_tvunit/livingroom_with_tvunitwithstorage (1).jpg'
import livingroomwithtvunit2 from '../../assets/designgallery/LivingRoom/livingroom_with_tvunit/livingroom_with_tvunitwithstorage (2).jpg'
import livingroomwithtvunit3 from '../../assets/designgallery/LivingRoom/livingroom_with_tvunit/livingroom_with_tvunitwithstorage (3).jpg'
import livingroomwithtvunit4 from '../../assets/designgallery/LivingRoom/livingroom_with_tvunit/livingroom_with_tvunitwithstorage (4).jpg'
import livingroomwithtvunit5 from '../../assets/designgallery/LivingRoom/livingroom_with_tvunit/livingroom_with_tvunitwithstorage (5).jpg'
import livingroomwithtvunit6 from '../../assets/designgallery/LivingRoom/livingroom_with_tvunit/livingroom_with_tvunitwithstorage (6).jpg'


import wfhlivingroom1 from '../../assets/designgallery/LivingRoom/wfhfriendly_livingroom/wfhfriendlylivingroom (1).jpg'
import wfhlivingroom2 from '../../assets/designgallery/LivingRoom/wfhfriendly_livingroom/wfhfriendlylivingroom (2).jpg'
import wfhlivingroom3 from '../../assets/designgallery/LivingRoom/wfhfriendly_livingroom/wfhfriendlylivingroom (3).jpg'
import wfhlivingroom4 from '../../assets/designgallery/LivingRoom/wfhfriendly_livingroom/wfhfriendlylivingroom (4).jpg'
import wfhlivingroom5 from '../../assets/designgallery/LivingRoom/wfhfriendly_livingroom/wfhfriendlylivingroom (5).jpg'
import wfhlivingroom6 from '../../assets/designgallery/LivingRoom/wfhfriendly_livingroom/wfhfriendlylivingroom (9).jpg'


import industrial1 from '../../assets/designgallery/LivingRoom/industrialstyle_livingroom/industrial_livingroom (1).jpg'
import industrial2 from '../../assets/designgallery/LivingRoom/industrialstyle_livingroom/industrial_livingroom (9).jpg'
import industrial3 from '../../assets/designgallery/LivingRoom/industrialstyle_livingroom/industrial_livingroom (3).jpg'
import industrial4 from '../../assets/designgallery/LivingRoom/industrialstyle_livingroom/industrial_livingroom (4).jpg'
import industrial5 from '../../assets/designgallery/LivingRoom/industrialstyle_livingroom/industrial_livingroom (5).jpg'
import industrial6 from '../../assets/designgallery/LivingRoom/industrialstyle_livingroom/industrial_livingroom (6).jpg'

import smallapartmentliving1 from '../../assets/designgallery/LivingRoom/smallapartments_livingroom/livingroomfor_smallapartments (1).jpg'
import smallapartmentliving2 from '../../assets/designgallery/LivingRoom/smallapartments_livingroom/livingroomfor_smallapartments (10).jpg'
import smallapartmentliving3 from '../../assets/designgallery/LivingRoom/smallapartments_livingroom/livingroomfor_smallapartments (3).jpg'
import smallapartmentliving4 from '../../assets/designgallery/LivingRoom/smallapartments_livingroom/livingroomfor_smallapartments (4).jpg'
import smallapartmentliving5 from '../../assets/designgallery/LivingRoom/smallapartments_livingroom/livingroomfor_smallapartments (5).jpg'
import smallapartmentliving6 from '../../assets/designgallery/LivingRoom/smallapartments_livingroom/livingroomfor_smallapartments (6).jpg'

import livingroomwithpoojaunit1 from '../../assets/designgallery/LivingRoom/livingroomwith_poojaunt/livingroomwith_poojaunit (1).jpg'
import livingroomwithpoojaunit2 from '../../assets/designgallery/LivingRoom/livingroomwith_poojaunt/livingroomwith_poojaunit (7).jpg'
import livingroomwithpoojaunit3 from '../../assets/designgallery/LivingRoom/livingroomwith_poojaunt/livingroomwith_poojaunit (3).jpg'
import livingroomwithpoojaunit4 from '../../assets/designgallery/LivingRoom/livingroomwith_poojaunt/livingroomwith_poojaunit (8).jpg'
import livingroomwithpoojaunit5 from '../../assets/designgallery/LivingRoom/livingroomwith_poojaunt/livingroomwith_poojaunit (5).jpg'
import livingroomwithpoojaunit6 from '../../assets/designgallery/LivingRoom/livingroomwith_poojaunt/livingroomwith_poojaunit (6).jpg'
import { BiSolidOffer } from 'react-icons/bi';
import { MdOutlineReplay10, MdOutlineThumbUpAlt } from 'react-icons/md';

const LivingRoom = () => {
  // *****************************************
  const [isExpanded1, setIsExpanded1] = useState(true);
  const toggleContent1 = () => {
    setIsExpanded1(prev => !prev);
  };
  // *****************************************
  // *****************************************
  const [isExpanded2, setIsExpanded2] = useState(false);
  const toggleContent2 = () => {
    setIsExpanded2(prev => !prev);
  };
  // *****************************************
  return (
    <div className='living-room design-gallery'>
        <div className='living-room-heading container'>
            <h3>Living Room Designs</h3>
            <p className='para'>
                Explore living room designs with stylish furniture, smart storage, false ceilings, TV units & more.
                 Transform your space — Get inspired & design your dream living room!
            </p>
        </div>
        {/* ***************************************** */}
        <div className='shapes container'>
            {/* slider 1 */}
            <div id="carouselExampleIndicators" class="carousel slide">
                        <div class="carousel-indicators">
                          <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                          <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
                          <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
                          <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3" aria-label="Slide 4"></button>
                          <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="4" aria-label="Slide 5"></button>
                          <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="5" aria-label="Slide 6"></button>
                        </div>
                      <div class="carousel-inner">
                          <div class="carousel-item active">
                            <img src={livingroomwithtvunit1} class="d-block w-100" alt="..."/>
                          </div>
                          <div class="carousel-item">
                            <img src={livingroomwithtvunit2} class="d-block w-100" alt="..."/>
                          </div>
                          <div class="carousel-item">
                            <img src={livingroomwithtvunit3} class="d-block w-100" alt="..."/>
                          </div>
                          <div class="carousel-item">
                            <img src={livingroomwithtvunit4} class="d-block w-100" alt="..."/>
                          </div>
                          <div class="carousel-item">
                            <img src={livingroomwithtvunit5} class="d-block w-100" alt="..."/>
                          </div>
                          <div class="carousel-item">
                            <img src={livingroomwithtvunit6} class="d-block w-100" alt="..."/>
                        </div>
                      </div>
                      <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Previous</span>
                      </button>
                      <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Next</span>
                      </button>
            </div>
            <div className='images-details mt-3'>
                            <p className='img-details-and-btn'> A Modern Living Room With A TV Unit Designed With Storage<Link className='btn form-btn' to="/form">Get a Quote</Link></p>
                             {/* Show more button */}
                             {!isExpanded1 && (
                                <button 
                                  className='show-more btn mt-2'
                                  onClick={toggleContent1}
                                  aria-expanded={isExpanded1}
                                >
                                 Show More ▼  
                                </button>
                             )}

                             {/* Expanded content */}
                             {isExpanded1 &&(
                                <div className='extra-info mt-3'>
                                    <p className='extra-info-para'>
                                       This living room is designed to utilise space efficiently to give this area a clurtter-free look.
                                       It  comes with sectional sofa upholstered with pockets on the side to store magazines and newspapers.
                                       The room also has a completely-modular TV unit in grey and light wood laminate designed with ample storage.
                                       Cabinets at the boyyom and open shelves on top.
                                    </p>
                                    <p className='extra-info-features'>Special Features</p>
                                    <ul className='extra-info-list'>
                                        <li>A multifunctional compact TV unit that has enough storage shelves and cabinets to maintain a clutter-free look.</li>
                                        <li>A sectional sofa unpholstered in white fabric with side cover pockets to stack reading material </li>
                                        <li>Two marble top coffee tables complement the white and grey colour palette of the room.</li>
                                        <li>A textured wall in white behind the sofa ties the look of this space together</li>
                                        <li>A jali patterned partition in white adds to the aesthetics  of the space and separates the living area from the rest of the home</li>
                                        <li>Warm lightings in the side table lamp and a chandelier accentuate the homely ambience of the room</li>
                                        <li>white and beige curtains complete the look of the room</li>
                                    </ul>

                                 {/* Show less button */}
                                 <button
                                  className='show-less btn  mt-3'
                                  onClick={toggleContent1}
                                  aria-expanded={isExpanded1}
                                  >
                                   Show Less ▲  
                                  </button>
                                </div>
                             )}
                            
            </div>
            {/*slider 1 end  */}
            <div style={{margin:'80px'}}  ></div>
            {/* slider 2 */}
            <div id="carouselExampleIndicators1" class="carousel slide">
                        <div class="carousel-indicators">
                          <button type="button" data-bs-target="#carouselExampleIndicators1" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                          <button type="button" data-bs-target="#carouselExampleIndicators1" data-bs-slide-to="1" aria-label="Slide 2"></button>
                          <button type="button" data-bs-target="#carouselExampleIndicators1" data-bs-slide-to="2" aria-label="Slide 3"></button>
                          <button type="button" data-bs-target="#carouselExampleIndicators1" data-bs-slide-to="3" aria-label="Slide 4"></button>
                          <button type="button" data-bs-target="#carouselExampleIndicators1" data-bs-slide-to="4" aria-label="Slide 5"></button>
                          <button type="button" data-bs-target="#carouselExampleIndicators1" data-bs-slide-to="5" aria-label="Slide 6"></button>
                        </div>
                      <div class="carousel-inner">
                          <div class="carousel-item active">
                            <img src={ wfhlivingroom1} class="d-block w-100" alt="..."/>
                          </div>
                          <div class="carousel-item">
                            <img src={wfhlivingroom2} class="d-block w-100" alt="..."/>
                          </div>
                          <div class="carousel-item">
                            <img src={wfhlivingroom3} class="d-block w-100" alt="..."/>
                          </div>
                          <div class="carousel-item">
                            <img src={wfhlivingroom4} class="d-block w-100" alt="..."/>
                          </div>
                          <div class="carousel-item">
                            <img src={wfhlivingroom5} class="d-block w-100" alt="..."/>
                          </div>
                          <div class="carousel-item">
                            <img src={wfhlivingroom6} class="d-block w-100" alt="..."/>
                        </div>
                      </div>
                      <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators1" data-bs-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Previous</span>
                      </button>
                      <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators1" data-bs-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Next</span>
                      </button>
            </div>
            <div className='images-details mt-3'>
                            <p className='img-details-and-btn'>A WFH Friendly Living Room For Working Professionals <Link className='btn form-btn' to="/form">Get a Quote</Link></p>
                             {/* Show more button */}
                             {!isExpanded2 && (
                                <button 
                                  className='show-more btn mt-2'
                                  onClick={toggleContent2}
                                  aria-expanded={isExpanded2}
                                >
                                 Show More ▼  
                                </button>
                             )}

                             {/* Expanded content */}
                             {isExpanded2 &&(
                                <div className='extra-info mt-3'>
                                    <p className='extra-info-para'>
                                       This contemporary living room boasts a striking combination of whites, blues and greys to create the perfect atmosphere.
                                       It works as a multi-functional room with bookshelves, 
                                       study and work unit alongside a TV unit, perfect for young urban couples and working professionals.

 
                                    </p>
                                    <p className='extra-info-features'>Special Features</p>
                                    <ul className='extra-info-list'>
                                      <li>A contemporary living room with mid-century furnishing.</li>
                                      <li>The seating features a 3-seater sofa, a comfortable accent chair and two-tiered wooden round coffee table in mid-century design.</li>
                                      <li>The seating space hosts a tall storage unit with multiple storage components like the shutter units on top, open shelves in the middle and handleless drawers on the bottom.</li>
                                      <li>The TV unit features a minimalist space-saving solution with a floating box shelf on the side and a quirky open unit that extends into two drawer units on the side.</li>
                                      <li>The TV unit extends into a study/home office unit and features a wall-mounted cabinet in blue for storing documents and work essentials</li>
                                      <li>The study/work unit comprises a desk with a pull-to-open drawers and an EAMES chair with a comfortable backrest.</li>
                                    </ul>

                                 {/* Show less button */}
                                 <button
                                  className='show-less btn  mt-3'
                                  onClick={toggleContent2}
                                  aria-expanded={isExpanded2}
                                  >
                                   Show Less ▲  
                                  </button>
                                </div>
                             )}
                            
            </div>
            {/*slider 2 end  */}
            <div style={{margin:'80px'}}  ></div>

        </div>
        

        {/*  */}
           <div className='shapes container'>
            {/* slider 3 */}
            <div id="carouselExampleIndicators2" class="carousel slide">
                        <div class="carousel-indicators">
                          <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                          <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="1" aria-label="Slide 2"></button>
                          <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="2" aria-label="Slide 3"></button>
                          <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="3" aria-label="Slide 4"></button>
                          <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="4" aria-label="Slide 5"></button>
                          <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="5" aria-label="Slide 6"></button>
                        </div>
                      <div class="carousel-inner">
                          <div class="carousel-item active">
                            <img src={industrial1} class="d-block w-100" alt="..."/>
                          </div>
                          <div class="carousel-item">
                            <img src={industrial2} class="d-block w-100" alt="..."/>
                          </div>
                          <div class="carousel-item">
                            <img src={industrial3} class="d-block w-100" alt="..."/>
                          </div>
                          <div class="carousel-item">
                            <img src={industrial4} class="d-block w-100" alt="..."/>
                          </div>
                          <div class="carousel-item">
                            <img src={industrial5} class="d-block w-100" alt="..."/>
                          </div>
                          <div class="carousel-item">
                            <img src={industrial6} class="d-block w-100" alt="..."/>
                        </div>
                      </div>
                      <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Previous</span>
                      </button>
                      <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Next</span>
                      </button>
            </div>
            <div className='images-details mt-3'>
                            <p className='img-details-and-btn'> Industrial Style Living Room Interior Design<Link className='btn form-btn' to="/form">Get a Quote</Link></p>
                             {/* Show more button */}
                             {!isExpanded2 && (
                                <button 
                                  className='show-more btn mt-2'
                                  onClick={toggleContent2}
                                  aria-expanded={isExpanded2}
                                >
                                 Show More ▼  
                                </button>
                             )}

                             {/* Expanded content */}
                             {isExpanded2 &&(
                                <div className='extra-info mt-3'>
                                    <p className='extra-info-para'>
                                       Wood and marble finishes blend together in one industrial style living room.
                                       Wooden flooring and an exposed brick wall behind the sofa add to the interior design style.
                                    </p>
                                    <p className='extra-info-features'>Special Features</p>
                                    <ul className='extra-info-list'>
                                       <li>A large TV unit with marble black panelling that brings in character.</li>
                                       <li>A floor mounted bookshelf with open and closed storage options as part of the TV unit.</li>
                                    </ul>

                                 {/* Show less button */}
                                 <button
                                  className='show-less btn  mt-3'
                                  onClick={toggleContent2}
                                  aria-expanded={isExpanded2}
                                  >
                                   Show Less ▲  
                                  </button>
                                </div>
                             )}
                            
            </div>
            {/*slider 3 end  */}
            <div style={{margin:'80px'}}  ></div>
            {/* slider 4 */}
            <div id="carouselExampleIndicators3" class="carousel slide">
                        <div class="carousel-indicators">
                          <button type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                          <button type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="1" aria-label="Slide 2"></button>
                          <button type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="2" aria-label="Slide 3"></button>
                          <button type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="3" aria-label="Slide 4"></button>
                          <button type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="4" aria-label="Slide 5"></button>
                          <button type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="5" aria-label="Slide 6"></button>
                        </div>
                      <div class="carousel-inner">
                          <div class="carousel-item active">
                            <img src={smallapartmentliving1} class="d-block w-100" alt="..."/>
                          </div>
                          <div class="carousel-item">
                            <img src={smallapartmentliving2} class="d-block w-100" alt="..."/>
                          </div>
                          <div class="carousel-item">
                            <img src={smallapartmentliving3} class="d-block w-100" alt="..."/>
                          </div>
                          <div class="carousel-item">
                            <img src={smallapartmentliving4} class="d-block w-100" alt="..."/>
                          </div>
                          <div class="carousel-item">
                            <img src={smallapartmentliving5} class="d-block w-100" alt="..."/>
                          </div>
                          <div class="carousel-item">
                            <img src={smallapartmentliving6} class="d-block w-100" alt="..."/>
                        </div>
                      </div>
                      <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Previous</span>
                      </button>
                      <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Next</span>
                      </button>
            </div>
            <div className='images-details mt-3'>
                            <p className='img-details-and-btn'> Modern Style Living Room For Small Apartments<Link className='btn form-btn' to="/form">Get a Quote</Link></p>
                             {/* Show more button */}
                             {!isExpanded2 && (
                                <button 
                                  className='show-more btn mt-2'
                                  onClick={toggleContent2}
                                  aria-expanded={isExpanded2}
                                >
                                 Show More ▼  
                                </button>
                             )}

                             {/* Expanded content */}
                             {isExpanded2 &&(
                                <div className='extra-info mt-3'>
                                    <p className='extra-info-para'>
                                      An all-while living room designed for small apartments. Smartly designed furniture helps with space maximisation.
                                    </p>
                                    <p className='extra-info-features'>Special Features</p>
                                    <ul className='extra-info-list'>
                                      <li>A study unit with drawers on either side and a while marker board for quick notes. </li>
                                      <li>A TV unit with vertical wood panellingand open shelves for display .</li>
                                    </ul>

                                 {/* Show less button */}
                                 <button
                                  className='show-less btn  mt-3'
                                  onClick={toggleContent2}
                                  aria-expanded={isExpanded2}
                                  >
                                   Show Less ▲  
                                  </button>
                                </div>
                             )}
                            
            </div>
            {/*slider 4 end  */}
            <div style={{margin:'80px'}}  ></div>

             {/* slider 5 */}
            <div id="carouselExampleIndicators4" class="carousel slide">
                        <div class="carousel-indicators">
                          <button type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                          <button type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide-to="1" aria-label="Slide 2"></button>
                          <button type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide-to="2" aria-label="Slide 3"></button>
                          <button type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide-to="3" aria-label="Slide 4"></button>
                          <button type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide-to="4" aria-label="Slide 5"></button>
                          <button type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide-to="5" aria-label="Slide 6"></button>
                        </div>
                      <div class="carousel-inner">
                          <div class="carousel-item active">
                            <img src={livingroomwithpoojaunit1} class="d-block w-100" alt="..."/>
                          </div>
                          <div class="carousel-item">
                            <img src={livingroomwithpoojaunit2} class="d-block w-100" alt="..."/>
                          </div>
                          <div class="carousel-item">
                            <img src={livingroomwithpoojaunit3} class="d-block w-100" alt="..."/>
                          </div>
                          <div class="carousel-item">
                            <img src={livingroomwithpoojaunit4} class="d-block w-100" alt="..."/>
                          </div>
                          <div class="carousel-item">
                            <img src={livingroomwithpoojaunit5} class="d-block w-100" alt="..."/>
                          </div>
                          <div class="carousel-item">
                            <img src={livingroomwithpoojaunit6} class="d-block w-100" alt="..."/>
                        </div>
                      </div>
                      <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Previous</span>
                      </button>
                      <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Next</span>
                      </button>
            </div>

            <div className='images-details mt-3'>
                          <p className='img-details-and-btn'> Modern Style Living Room For Small Apartments<Link className='btn form-btn' to="/form">Get a Quote</Link></p>
                            {/* Show more button */}
                            {!isExpanded2 && (
                              <button 
                                className='show-more btn mt-2'
                                onClick={toggleContent2}
                                aria-expanded={isExpanded2}
                              >
                                Show More ▼  
                              </button>
                            )}

                            {/* Expanded content */}
                            {isExpanded2 &&(
                              <div className='extra-info mt-3'>
                                  <p className='extra-info-para'>
                                    An all-while living room designed for small apartments. Smartly designed furniture helps with space maximisation.
                                  </p>
                                  <p className='extra-info-features'>Special Features</p>
                                  <ul className='extra-info-list'>
                                    <li>A study unit with drawers on either side and a while marker board for quick notes. </li>
                                    <li>A TV unit with vertical wood panellingand open shelves for display .</li> 
                                  </ul>

                                {/* Show less button */}
                                <button
                                className='show-less btn  mt-3'
                                onClick={toggleContent2}
                                aria-expanded={isExpanded2}
                                >
                                  Show Less ▲  
                                </button>
                              </div>
                            )}
                          
           </div>
            {/*slider 5 end  */}
            <div style={{margin:'80px'}}  ></div>
            




           </div>
            {/*whychooseourkitchen*/}
                    <div className='whyourkitchen'>
                      <h3>Why Choose Our Living Room Designs</h3>
                      <div className='whyourkitchen-reason'>
                        <div className='icon-para-div1'>
                            <BiSolidOffer className='icon'/>
                            <p className='whyourkitchen-para'>20% Extra Space</p>
                        </div>
                        <div className='icon-para-div1'>
                            <MdOutlineReplay10  className='icon'/>
                            <p className='whyourkitchen-para'>10 Year Warranty</p>
                        </div>
                        <div className='icon-para-div1'>
                            <MdOutlineThumbUpAlt  className='icon'/>
                            <p className='whyourkitchen-para'>Installation by Professionals</p>
                        </div>
                      </div>
                    </div>
        {/*whychooseourkitchen*/}
        {/* FAQ's for space saving design */}
       <div className=' design gallery faq'>
        <h2 className=' design faq-heading'>Frequently asked questions on Space Saving Designs</h2>
        {/* <Link to="/contactForm" classNameName="btn btn-warning">Enquiry Form</Link> */}
        <div className="container accordion accordion-flush" id="accordionFlushExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                1. What is the most effective wayn to design a living room ?
              </button>
            </h2>
            <div id="flush-collapseOne" className="accordion-collapse collapse" >
              <div className="accordion-body">
                <ul>
                  <li>Designing the perfect living room interior is all about finding the right balance between style and comfort </li>
                  <li>Start by thinking about how you will use the space-whether it is for unwiding after a long day, entertaining guests, or mix of both. Choose a colour palatte that sets the mood and complements your home's overall aesthetic.</li>
                  <li>A cosy yet functional seating arrangement is key, so invest in a comfortable sofa, accent chairs and a coffee table that brings everything together.</li>
                  <li>Layering different types of lighting-overhead,task ad accent-will addd warmth and depth</li>
                  <li>Finally, don't forget the details! Rugs, curtains,cushions and a few personal touches like artwork or plants will make your living room design truly feel like home.</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                2. What are the essential elements of a well-designed living room ?
              </button>
            </h2>
            <div id="flush-collapseTwo" className="accordion-collapse collapse" >
              <div className="accordion-body">
               A beautifully designed living room interior isn't just about looking good-it should feel inviting and 
               work effortlessly for your lifestyle. Here are some must-have elements

               <ul>
                <li><b>A Focal Point : </b>this could be a statement wall, a TV unit, a fireplace or even a large window with stunning view.</li>
                <li><b>Comfortable Seating : </b>Whether it is a spacious sofa, cosy armchairs or a stylish sectional your seating should encourage relaxation and conversation. </li>
                <li><b>Well-Planned Lighting</b>A mix of natural light, ceilling fixtures and wazrm accent lighting brings out the best in your living room interior design.</li>
                <li><b>Smart Furniture Choices</b>If space is limited, opt for multifunctional furniture with built-in storage to keep thigs neat and clutter-free.</li>
                <li><b>Textures and Layers</b>Soft furnishings like rugs, cushions and curtains add warmth ,while decor pieces like vases,books and wall art bring personality.</li>
               </ul><br/>
               No matter your style- modern , traditional or mix of both -these elements will help you create
               a living room design that is both stylish and functional.
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
                3.How can i determine the best layout for my living room?
              </button>
            </h2>
            <div id="flush-collapseThree" className="accordion-collapse collapse" >
              <div className="accordion-body">
                The right layout can completely transform your living room interior design, 
                making it feel more open , cosy or social depending on your needs.

                <ul>
                  <li><b>Start with a focal point : </b>whether it is a TV, fireplace or statement decor piece , arrange your seating around it.</li>
                  <li><b>Maximize space in small living rooms : </b>opt fro space-saving furniture like a modular sofa or nesting tables.</li>
                  <li><b>Define zones in open-plan layouts : </b>use rugs and furniture placement to create distinct areas like a lounge space or reading nook. </li>
                  <li><b>Ensure easy movement</b>maintain at least a metre of space between furniture to keep the room comfortable and clutter-fee</li>
                  <li><b>Create the illusion of space : </b>in long narrow living rooms , place furniture along one wall and use mirrors to enhance openness</li>
                </ul> <br/>
                No matter your style , a well-thought-out living room design ensures a layout that is both practical and inviting.
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFour" aria-expanded="false" aria-controls="flush-collapseFour">
                4.what are the different styles of living room designs?
              </button>
            </h2>
            <div id="flush-collapseFour" className="accordion-collapse collapse" >
              <div className="accordion-body">
               There is no one-size-fits-all approach to living  room design-it all depends on your 
               taste and lifestyle, Some popular styles include :
               <ul>
                <li><b>Modern : </b>Sleek,simple and stylish often blending modern design with bold colours and unique accents.</li>
                <li><b>Traditional : </b>Warm and elegant , featuring rich wooden furniture,intricate patterns and timeless decor.</li>
                <li><b>Minimalist</b>Less is more! Clean spaces, neutral palettes and functional furniture define this look.</li>
                <li><b>Industrial  : </b>A raw , edgy style with exposed brick, metal fixtures and rustic textures.</li>
                <li><b>Bohemian : </b>A mix of colours, patterns and textures for a cosy, lived-in feel.</li>
                <li><b>Contemporary : </b>Always evolving, often blending modern design with bold colours and unique accents.</li>
                <li><b>Scandinavian</b>Light, airy and effortlessly cosy with soft hues and natural materials.</li>
               </ul>
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFive" aria-expanded="false" aria-controls="flush-collapseFive">
                5. What are the latest living room interior design trends for 2025 ?
              </button>
            </h2>
            <div id="flush-collapseFive" className="accordion-collapse collapse" >
              <div className="accordion-body">
                 if you are planning a home refresh, 205s living room interior design trends focus on <b>comfot, sustainability and self expression.</b>
                 Here's what's making waves : 
                 <ul>
                  <li><b>Earthy and Neutral Tones : </b>Soft beiges,olive greens and warm browns create a soothing vibe.</li>
                  <li><b>Biophilic : </b>Bringing the outdoors in with indoor plants, woden textures and some finishes.</li>
                  <li><b>Smart and Multifunctional Spaces</b>Modular sofas, hidden storage and space-saving furniture make small living room designs more functional.</li>
                  <li><b>Statement Lighting : </b>Oversized pendant lights and sculptural fixtures that double as art pieces.</li>
                  <li><b>Rich Textures and Patterns</b>Boucle fabrics, 3D wall panels, and layered rugd and depth and character.</li>
                  <li><b>Sustainble Materials</b>Eco-friendly choices like bamboo, rattan and recycled fabrics are treanding in living room interior design in india.</li>
                 </ul><br/>
                 
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseSix" aria-expanded="false" aria-controls="flush-collapseSix">
                6. How can i create a luxurious living room interior?
              </button>
            </h2>
            <div id="flush-collapseSix" className="accordion-collapse collapse" >
              <div className="accordion-body">
                Luxury in living room interior design isn't just about expensive furniture-it is about creating an elegant , well-curated space.
                <ul>
                  <li>Start with high-quality seating, like a plush velvet sofa or a chic sectional, to add comfort and sophistication.</li>
                  <li>Choose a rich colour palatte-neutrals with pops of jewel tones like emerald green or royal blue work beautifully.</li>
                  <li>Metalic accents in gold, brass or chrome instantly elevate the space</li>
                  <li>Layer your lighting with chandeliers, floor lamps and soft LED strips for a warm, inviting glow</li>
                  <li>Incorporate luxu textures with silk cushions,textured wallpapers and statement rugs.</li>
                  <li>Finally , add a few curated decor pieces-whether it is striking artwork ,a sculptural coffee table or fresh flowers-to tie it all together</li>
                </ul><br/>
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseSeven" aria-expanded="false" aria-controls="flush-collapseSeven">
                7. Which living room designs are best suited for infian homes?
              </button>
            </h2>
            <div id="flush-collapseSeven" className="accordion-collapse collapse" >
              <div className="accordion-body">
              Indian homes need living room designs that ar stylish yet practical, balancing tradition with modern living.
              Here are some of the best styles : 
              <ul>
                <li><b>Traditional indian : </b>Ornate wooden furniture, carved accents, brass décor, and bright textiles for a timeless appeal.</li>
                <li><b>Modern Indian : </b> A fusion of contemporary style with classic touches, featuring muted tones and minimalist décor.</li>
                <li><b>Vaastu-Compliant Layouts : </b>Arranging furniture and décor according to Vaastu principles for positive energy and harmony in the living room interior.</li>
                <li><b>Space-Saving Designs : </b> Ideal for compact urban homes, with smart storage solutions, foldable furniture, and sleek layouts.</li>
                <li><b>Courtyard-Inspired</b> Open, airy spaces with natural elements like indoor plants, wooden floors, and cross-ventilation.</li>
                <li><b>Luxury Indian Fusion : </b> A blend of marble flooring, statement lighting, and handcrafted Indian artefacts to create an opulent yet warm feel.</li>
              </ul><br/>
              Whether you love traditional elegance or a more modern look,
              thoughtful living room interior design in India can make your home feel stylish, functional, and uniquely yours.
                 
              </div>
            </div>
          </div>
        </div>
       </div>
           
        <p className='disclaimer container'>Kindly note: Product images are representative and may not reflect exact offerings. Please contact us to create a design customized for you.</p>
        
    </div>
  )
}

export default LivingRoom